<template>
  <div class="main-body">
    <el-tabs v-model="activeName">
      <el-tab-pane label="学习中课程" name="currentClass">

        <div class="infinite-list-wrapper" style="overflow:auto">
          <ul>
            <li v-for="item in initList" class="list-item">
              <div class="media">
                <div class="media-left">
                  <el-image :src="item.themeImg" style="width: 141px; height: 100px;"/>
                </div>
                <div class="media-body" style="padding: 0 15px 15px 15px;">
                  <h4 class="media-heading">{{item.themeName}}</h4>
                  <div style="padding: 4px; padding-left: 0px;">
                    <div
                      style="text-overflow: ellipsis; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">
                    </div>
                  </div>
                  <div>
                    <div>
                      已学
                      <span style="color: #f01414;"> {{item.learnProgress}} </span>
                      学习至<span style="color: #f01414;"> {{item.currentTaskName}}</span>
                    </div>
                    <div style="border-bottom: 1px solid #eeeeee; padding-bottom: 20px; text-align: right;">
                      <el-button type="primary" size="medium" icon="el-icon-edit" @click="pubContinue(item.themeCode)">
                        继续学习
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

      </el-tab-pane>
      <el-tab-pane label="已完成的课程" name="second">
        <div class="infinite-list-wrapper" style="overflow:auto">
          <ul>
            <li v-for="item in finishList" class="list-item">
              <div class="media">
                <div class="media-left">
                  <el-image :src="item.themeImg" style="width: 141px; height: 100px;"/>
                </div>
                <div class="media-body" style="padding: 0 15px 15px 15px;">
                  <h4 class="media-heading">{{item.themeName}}</h4>
                  <div style="padding: 4px; padding-left: 0px;">
                    <div
                      style="text-overflow: ellipsis; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">
                    </div>
                  </div>
                  <div>
                    <div>
                      已学
                      <span style="color: #f01414;"> {{item.learnProgress}} </span>
                    </div>
                    <div style="border-bottom: 1px solid #eeeeee; padding-bottom: 20px; text-align: right;">
                      <el-button type="primary" size="medium" @click="pubContinue(item.themeCode)">
                        重新学习
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { doGetAllInitUserLearnTask, doGetAllFinishUserLearnTask } from '@/utils/server';

  export default {
    name: "index",
    data() {
      return {
        activeName: 'currentClass',
        initList: [],
        finishList: []
      };
    },
    methods: {
      getAllInitUserLearnTask() {
        doGetAllInitUserLearnTask({})
          .then(response => {
            this.initList = response.data;
          })
      },
      getAllFinishUserLearnTask() {
        doGetAllFinishUserLearnTask({})
          .then(response => {
            this.finishList = response.data;
          })
      },
      pubContinue(themeCode, currentTaskId) {
        this.$router.push({ path: '/PubContinue', query: { themeCode: themeCode, currentTaskId: currentTaskId } });
      }
    },
    mounted() {
      this.getAllInitUserLearnTask();
      this.getAllFinishUserLearnTask();
    }
  }
</script>

<style scoped>
  .main-body {
    margin: 0 auto;
    width: 990px;
  }

  .media-body, .media-left {
    display: table-cell;
    vertical-align: top;
  }

  .media-body {
    zoom: 1;
    width: 10000px;
    overflow: hidden;
  }

  .infinite-list-wrapper ul li {
    list-style-type: none;
    color: #666666;
    padding: 20px 10px;
    margin-left: -40px;
  }

  .media-heading {
    margin-top: 0;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/userspace/currentclass/index.vue